/**
 * Ícones de traço (SVG em linha, sem biblioteca): herdam a cor do texto (`currentColor`) e são
 * decorativos por padrão (`aria-hidden`). O nome acessível fica no botão ou link que os contém.
 */
import type { SVGProps } from "react";

const PATHS = {
  inicio: ["M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z"],
  cadastros: [
    "M16 20v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
    "M5 7a4 4 0 1 0 8 0a4 4 0 1 0-8 0",
    "M22 20v-2a4 4 0 0 0-3-3.9",
    "M16 3.1a4 4 0 0 1 0 7.8",
  ],
  vendas: ["M6 7h12l1 13H5z", "M9 7a3 3 0 0 1 6 0"],
  fiscal: ["M7 3h7l5 5v13H7z", "M14 3v5h5", "M10 13h6", "M10 17h6"],
  compras: [
    "M3 6h11v10H3z",
    "M14 10h4l3 3v3h-7",
    "M5 18a2 2 0 1 0 4 0a2 2 0 1 0-4 0",
    "M15 18a2 2 0 1 0 4 0a2 2 0 1 0-4 0",
  ],
  financeiro: ["M3 7h18v12H3z", "M3 11h18", "M7 15h3"],
  producao: [
    "M5 9h11v5a5 5 0 0 1-5 5h-1a5 5 0 0 1-5-5z",
    "M16 11h2a2 2 0 0 1 0 4h-2",
    "M9 3c0 2 2 2 2 4",
    "M13 3c0 2 2 2 2 4",
  ],
  estoque: ["M3 8l9-5 9 5v8l-9 5-9-5z", "M3 8l9 5 9-5", "M12 13v8"],
  administracao: [
    "M4 6h9",
    "M17 6h3",
    "M15 4v4",
    "M4 12h3",
    "M11 12h9",
    "M9 10v4",
    "M4 18h11",
    "M19 18h1",
    "M17 16v4",
  ],
  plataforma: ["M4 4h7v7H4z", "M13 4h7v7h-7z", "M4 13h7v7H4z", "M13 13h7v7h-7z"],
  chevronRight: ["M9 6l6 6-6 6"],
  chevronDown: ["M6 9l6 6 6-6"],
  menu: ["M4 7h16", "M4 12h16", "M4 17h16"],
  close: ["M6 6l12 12", "M18 6L6 18"],
  search: ["M10 4a6 6 0 1 0 0 12a6 6 0 1 0 0-12", "M20 20l-5.5-5.5"],
  check: ["M5 12l5 5 9-10"],
  alert: ["M12 3l10 18H2z", "M12 10v5", "M12 18h.01"],
  info: ["M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18", "M12 11v6", "M12 7.5h.01"],
  inbox: ["M4 7h16v12H4z", "M4 7l2-3h12l2 3", "M9 12h6"],
  logout: ["M15 4h4v16h-4", "M10 8l-4 4 4 4", "M6 12h11"],
  collapse: ["M4 5h16v14H4z", "M9 5v14", "M15 10l-2 2 2 2"],
  expand: ["M4 5h16v14H4z", "M9 5v14", "M13 10l2 2-2 2"],
  swap: ["M7 7h11l-3-3", "M17 17H6l3 3"],
  arrowRight: ["M5 12h14", "M13 6l6 6-6 6"],
  pedidos: ["M8 4h8v3H8z", "M6 5H5v16h14V5h-1", "M9 12h6", "M9 16h4"],
  receber: ["M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18", "M12 7v8", "M8.5 11.5L12 15l3.5-3.5"],
  pagar: ["M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18", "M12 17V9", "M8.5 12.5L12 9l3.5 3.5"],
  plus: ["M12 5v14", "M5 12h14"],
  edit: ["M4 20h4l10-10-4-4L4 16z"],
  trash: ["M5 7h14", "M9 7V4h6v3", "M7 7l1 13h8l1-13"],
  printer: ["M7 9V3h10v6", "M5 9h14v8h-3", "M8 17H5", "M8 14h8v7H8z"],
  wifi: [
    "M2 9a15 15 0 0 1 20 0",
    "M5.5 12.5a10 10 0 0 1 13 0",
    "M9 16a5 5 0 0 1 6 0",
    "M12 19.5h.01",
  ],
  wifiOff: ["M2 2l20 20", "M8.5 16.4a5 5 0 0 1 7 0", "M5 12.5a10 10 0 0 1 5-2.4", "M12 19.5h.01"],
  download: ["M12 4v11", "M7 10l5 5 5-5", "M5 20h14"],
  share: ["M12 15V3", "M8 7l4-4 4 4", "M5 12v8h14v-8"],
  minus: ["M5 12h14"],
  user: ["M12 4a4 4 0 1 0 0 8a4 4 0 1 0 0-8", "M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1"],
  userPlus: [
    "M10 4a4 4 0 1 0 0 8a4 4 0 1 0 0-8",
    "M2 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 4.5 2",
    "M19 14v6",
    "M16 17h6",
  ],
  bluetooth: ["M7 7l10 10-5 4V3l5 4L7 17"],
  cart: [
    "M3 4h2l2.4 11h10.2L20 8H6.2",
    "M9 20a1 1 0 1 0 0-2a1 1 0 1 0 0 2",
    "M17 20a1 1 0 1 0 0-2a1 1 0 1 0 0 2",
  ],
  phone: [
    "M5 4h3l2 5-2.5 1.5a11 11 0 0 0 6 6L15 14l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2",
  ],
  truck: [
    "M2 6h12v10H2z",
    "M14 10h4l4 4v2h-8",
    "M5 18a2 2 0 1 0 4 0a2 2 0 1 0-4 0",
    "M15 18a2 2 0 1 0 4 0a2 2 0 1 0-4 0",
  ],
  wallet: ["M3 7h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", "M3 7l12-4v4", "M16 13h2"],
  receipt: ["M6 3h12v18l-3-2-3 2-3-2-3 2z", "M9 8h6", "M9 12h6", "M9 16h3"],
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size = 20,
  strokeWidth = 1.8,
  ...rest
}: { name: IconName; size?: number; strokeWidth?: number } & Omit<
  SVGProps<SVGSVGElement>,
  "children"
>) {
  return (
    <svg
      aria-hidden
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      {PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}

/** Marca do CaféGestor (grão de café). */
export function BrandMark({ size = 22 }: { size?: number }) {
  return (
    <svg
      aria-hidden
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#E0A26F"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <ellipse cx="12" cy="12" rx="6.5" ry="9" transform="rotate(35 12 12)" />
      <path d="M8.5 6.5c3 2.5 4 7.5 7 11" />
    </svg>
  );
}
